<div class="participant-details-container">
    <div class="main-score">
        <div class="event-header-live" *ngIf="isNewEDPScoreboard; else scores">
            <i class="live-icon"></i>
            <span class="period-name">{{ scoreboard.period?.name }} </span
            ><span *ngIf="!(eventSuspended || eventFinished)">
                &nbsp;• <span class="period-header">{{ ballsStrikesOuts }}</span></span
            >
        </div>
        <ng-template #scores>
            <div class="header">
                <div class="event-score">
                    <div class="score-container" [ngClass]="{ inactive: eventSuspended }">
                        <ms-score-card
                            [eventId]="event.id"
                            [participant1Score]="score.participant1.points"
                            [participant2Score]="score.participant2.points">
                        </ms-score-card>
                    </div>
                    <ms-event-timer
                        class="period-name"
                        [live]="event.live"
                        [start]="event.startDate"
                        [scoreboard]="event.scoreboard"></ms-event-timer>
                </div>
            </div>
        </ng-template>
        <div class="participant" *ngFor="let participant of event.participants; let i = index">
            <ms-participant-image
                class="participant-logo"
                [participantImage]="event.participants[i].image"
                [sportId]="event.sport.id"
                [shouldRotate]="rotateImage[i]"
                [showLogoColor]="showLogoColor">
            </ms-participant-image>
            <ms-scoreboard-participant
                class="participant-info"
                [showIndicator]="false"
                [event]="event"
                [participant]="event.participants[i]"
                [isNewEDPScoreboard]="isNewEDPScoreboard">
            </ms-scoreboard-participant>
        </div>
    </div>
</div>
<ms-baseball-scoreboard-live
    [isShowcase]="isShowcase"
    [scoreboard]="scoreboard"
    [event]="event"
    [isNewEDPScoreboard]="isNewEDPScoreboard"
    [eventSuspended]="eventSuspended">
</ms-baseball-scoreboard-live>
